module.exports = __webpack_public_path__ + "assets/media/lunch.a2579763.mp3";